import type {
  ProfileModuleDto,
  ProfileTemplateFieldMode,
} from '@up2stay/up2promo-api-client';

import { ProfileModulesSection } from '@/core/components/profile/profile-modules-section';
import type { TemplateMemberValuesEditorUiProps } from '@/core/components/profile-templates/template-policy-member-controls';

type TemplateDetailModulesTabProps = {
  modules: ProfileModuleDto[];
  onModulesChange: (next: ProfileModuleDto[]) => void;
  isWorkspaceProfile: boolean;
  templateTeamIds: string[];
  canEditTemplate: boolean;
  disabled: boolean;
  policyLabels: { locked: string; free: string };
  onModuleEntryPolicyChange: (
    moduleId: string,
    entryId: string,
    mode: ProfileTemplateFieldMode,
  ) => void;
  memberValueProps: TemplateMemberValuesEditorUiProps;
};

export function TemplateDetailModulesTab({
  modules,
  onModulesChange,
  isWorkspaceProfile,
  templateTeamIds,
  canEditTemplate,
  disabled,
  policyLabels,
  onModuleEntryPolicyChange,
  memberValueProps,
}: TemplateDetailModulesTabProps) {
  return (
    <div className="flex min-w-0 flex-col gap-3 w-full">
      <ProfileModulesSection
        modules={modules}
        onModulesChange={onModulesChange}
        isWorkspaceProfile={isWorkspaceProfile}
        templateTeamIds={templateTeamIds}
        showManageTeamLink={canEditTemplate}
        readOnly={disabled}
        structureReadOnly={false}
        showEntryPolicies={canEditTemplate}
        onModuleEntryPolicyChange={onModuleEntryPolicyChange}
        policyLabels={policyLabels}
        {...memberValueProps}
      />
    </div>
  );
}
